import React from 'react';
import PropTypes from 'prop-types';

function FormWrapper({
     legend,
     onSubmit,
     formClassName,
     fieldsetClassName,
     children,
 }) {
    const formSubmitHandler = (event) => {
        event.preventDefault();
        onSubmit && onSubmit();
    };

    return (
        <form method='post' className={formClassName || 'form'} onSubmit={formSubmitHandler}>
            <div className={fieldsetClassName || 'form__fieldset'}>
                <fieldset className='form__fieldsetinner'>
                    {legend && (
                        <legend className='form__legend'>
                              <span className='form__legend__text'>
                                  {legend}
                              </span>
                        </legend>
                    )}

                    {children}
                </fieldset>
            </div>
        </form>
    )

}

FormWrapper.propTypes = {
    onSubmit: PropTypes.func,
    formClassName: PropTypes.string,
    fieldsetClassName: PropTypes.string,
};

export default FormWrapper;